import selectors from "./selectors";
import slice, { saga } from "./slice";

const supportReducer = slice.reducer;
const supportActions = slice.actions;
const supportSaga = saga;
const supportSelectors = selectors;

export { supportReducer, supportActions, supportSaga, supportSelectors };
